import React from 'react';
import {connect} from 'react-redux';
import queryString from 'query-string';
import UserEditor from './EditorPages/UserEditor';
import UserResults from './ResultsPages/UserResults';

function Users({
    urlParams
}) {
    const queryParams = queryString.parse(urlParams);

    return (
        queryParams && queryParams['id'] ?
            <UserEditor id={queryParams['id']} /> :
            <UserResults />
    );
}

const mapStateToProps = (state) => ({
    urlParams: state.router.location.search,
});

export default connect(mapStateToProps, null)(Users);